import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import LoaiQuyHoach from './loai-quy-hoach';
import LoaiQuyHoachDetail from './loai-quy-hoach-detail';
import LoaiQuyHoachUpdate from './loai-quy-hoach-update';
import LoaiQuyHoachDeleteDialog from './loai-quy-hoach-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={LoaiQuyHoachUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={LoaiQuyHoachUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={LoaiQuyHoachDetail} />
      <ErrorBoundaryRoute path={match.url} component={LoaiQuyHoach} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={LoaiQuyHoachDeleteDialog} />
  </>
);

export default Routes;
